exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#servitudeRegisterModal .v--modal-box.v--modal{min-height:450px!important;min-width:900px!important}#servitudeRegisterModal .modal__content{overflow-y:hidden!important}#servitudeRegisterModal .modal__footer{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0200a15d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/servitude/modals/ServitudeRegister.vue
// module id = 1896
// module chunks = 0